/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export var PhoneType;
(function (PhoneType) {
    PhoneType["MOBILE"] = "mobile";
})(PhoneType || (PhoneType = {}));
